import { ShareRoute } from '@/system-modules/share/v1/api/ShareRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { ILink } from '@/contracts/system-modules/share/ILink'

export class GetLinksRoute extends ShareRoute<null, ILink[]> {
  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/system/v1/share/links'
  }

  /** Без сервера ссылок нет */
  offline(): Promise<ApiResponse<ILink[]>> {
    return Promise.resolve(new ApiResponse({ success: true, data: [] }))
  }
}
